import { Bell } from 'lucide-react'
import { useMemo } from 'react'
import { useNavigate } from 'react-router'

import {
  type CommandPaletteSection,
  useRegisterPaletteSection
} from '@/domains/command-palette'

import { useUnreadCount } from './use-unread-count'

export const NOTIFICATIONS_SECTION_ID = 'notifications'

/** navigation row in the command palette that routes to /notifications.
 * memoized on the unread count so the registry only thrashes when the
 * badge changes.
 */
export function useNotificationsSection(): CommandPaletteSection {
  const navigate = useNavigate()
  const unreadQuery = useUnreadCount()
  const count = unreadQuery.data?.count ?? 0
  return useMemo<CommandPaletteSection>(
    () => ({
      id: NOTIFICATIONS_SECTION_ID,
      title: 'Notifications',
      icon: Bell,
      group: 'Pages',
      badge: count,
      onSelect: () => void navigate('/notifications')
    }),
    [count, navigate]
  )
}

export function useRegisterNotificationsSection() {
  const section = useNotificationsSection()
  useRegisterPaletteSection(section)
}
